import { MultiSelectFilter, StaticFilter, DateTimeFilter } from '@dataGrid/components/columnFilters';
import { ReadOnlyLockStatusRenderer } from '@dataGrid/components/cellRenderer';
import appConstants from '@appConstants';

const getRoutesGridConfig = () => ({
  title: 'Routes',
  rowSelection: 'multiple',
  rowDeselection: true,
  columns: [
    {
      headerName: 'Category',
      field: 'categoryDisplay',
      headerTooltip: 'Route Category',
      pinned: "left",
      minWidth: appConstants.columnWidth.W_200,
      filter: MultiSelectFilter,
      filterParams: {
        width: appConstants.columnWidth.W_260
      }
    },
    {
      headerName: 'Route',
      field: 'routeName',
      headerTooltip: 'Route Name',
      pinned: "left",
      minWidth: appConstants.columnWidth.W_120,
      filter: MultiSelectFilter
    },
    {
      headerName: 'Status',
      field: 'lockStatus',
      headerTooltip: 'Lock Status',
      pinned: "left",
      minWidth: appConstants.columnWidth.LOCK_STATUS,
      cellClass: 'gridCell-leftAlign',
      cellRenderer: ReadOnlyLockStatusRenderer,
      filter: StaticFilter,
      filterParams: {
        staticOptions: Object.values(appConstants.routeLockStates)
      },
      editable: false
    },
    {
      headerName: 'Route Type',
      field: 'routeType',
      headerTooltip: 'Route Type (City/Trap)',
      minWidth: appConstants.columnWidth.W_120,
      filter: MultiSelectFilter
    },
    {
      headerName: 'Tlt Stops',
      field: 'totalStops',
      headerTooltip: 'Total Stops',
      minWidth: appConstants.columnWidth.TOTAL_STOPS,
      filter: MultiSelectFilter
    },
    {
      headerName: 'Tlt Bills',
      field: 'totalBills',
      headerTooltip: 'Total Bills',
      minWidth: appConstants.columnWidth.TOTAL_BILLS,
      filter: MultiSelectFilter
    },
    {
      headerName: 'Trailer Type',
      field: 'trailerType',
      headerTooltip: 'Trailer Type',
      minWidth: appConstants.columnWidth.TRAILER_TYPE,
      filter: MultiSelectFilter
    },
    {
      headerName: 'PSE',
      field: 'totalPallets',
      headerTooltip: 'PSE',
      minWidth: appConstants.columnWidth.W_80,
      filter: MultiSelectFilter
    },
    {
      headerName: 'Weight',
      field: 'totalWeight',
      headerTooltip: 'Weight',
      minWidth: appConstants.columnWidth.WEIGHT,
      filter: MultiSelectFilter
    },
    {
      headerName: 'Tlt Time',
      field: 'totalTime',
      headerTooltip: 'Total Time',
      minWidth: appConstants.columnWidth.TOTAL_TIME,
      filter: MultiSelectFilter
    },
    {
      headerName: 'Empty Time',
      field: 'emptyTime',
      headerTooltip: 'Empty Time',
      minWidth: appConstants.columnWidth.EMPTY_TIME,
      filter: DateTimeFilter,
      filterParams: {
        DATETYPE: appConstants.DATETYPES.TIME
      }
    },
    {
      headerName: 'Start Time',
      field: 'startTime',
      headerTooltip: 'Start Time',
      minWidth: appConstants.columnWidth.START_TIME,
      filter: DateTimeFilter,
      filterParams: {
        DATETYPE: appConstants.DATETYPES.TIME
      }
    }
  ]
});

export default getRoutesGridConfig;
